module.exports = __webpack_public_path__ + "img/yahoo-new.45bf4100.png";